'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _tools = require('./tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STYLE_DEFAULTS = {
  height: 64,
  width: 200
};

function getStyles() {
  var conf = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var styles = conf.styles || {};
  var width = (conf.width || STYLE_DEFAULTS.width) + 'px';
  var height = (conf.height || STYLE_DEFAULTS.height) + 'px';

  var baseStyles = {
    wrapper: {
      width: '100%',
      height: '100%'
    },
    tree: {
      minHeight: '100%',
      boxSizing: 'border-box',
      overflowY: 'auto',
      position: 'fixed',
      top: '0',
      left: '0',
      width: width,
      paddingTop: height,
      maxHeight: '100%',
      zIndex: '999'
    },
    content: {
      minHeight: '100%',
      boxSizing: 'border-box',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '100%',
      paddingLeft: width,
      paddingTop: height
    },
    inner: {
      position: 'relative'
    }
  };

  return (0, _tools.mergeStyles)(baseStyles, styles);
}

var NavWrapper = function (_Component) {
  _inherits(NavWrapper, _Component);

  function NavWrapper() {
    _classCallCheck(this, NavWrapper);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NavWrapper).apply(this, arguments));
  }

  _createClass(NavWrapper, [{
    key: 'render',
    value: function render() {

      var styles = getStyles(this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrapper },
        this.props.paperprops ? _react2.default.createElement(
          _Paper2.default,
          _extends({}, this.props.paperprops, { style: styles.tree }),
          _react2.default.createElement(
            'div',
            { style: styles.inner },
            this.props.navbar
          )
        ) : _react2.default.createElement(
          'div',
          { style: styles.tree },
          _react2.default.createElement(
            'div',
            { style: styles.inner },
            this.props.navbar
          )
        ),
        _react2.default.createElement(
          'section',
          { style: styles.content },
          _react2.default.createElement(
            'div',
            { style: styles.inner },
            this.props.children
          )
        )
      );
    }
  }]);

  return NavWrapper;
}(_react.Component);

exports.default = NavWrapper;


/** WEBPACK FOOTER **
 ** ../kettle-ui/lib/NavWrapper.js
 **/